import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ListCategories } from "../../actions/categoryAction";
import { ListProducts } from "../../actions/productAction";
import Axios from "../../axios/axios";
import Pagination from "../Pagination/Pagination";
import { FaDownload } from "react-icons/fa";
import QRCode from "qrcode";
import { QRCodeSVG } from "qrcode.react";
const LstProduct = () => {
  const dispatch = useDispatch();

  const [productListData, setProductList] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [isGeneratingQR, setIsGeneratingQR] = useState(false);

  const catList = useSelector((state) => state.catList);
  const { loading, error, categories } = catList;

  const productList = useSelector((state) => state.productList);
  // const { products } = productList;
  const [products, setProducts] = useState([]);
  console.log(products, "fghjk");

  const catDelete = useSelector((state) => state.catDelete);

  const [brands, setBrands] = useState([]);
  const [categorydata, setCategoryData] = useState([]);
  const [selectedBrandId, setSelectedBrandId] = useState("all");
  const [selectedCategoryId, setSelectedCategoryId] = useState("all");

  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = catDelete;

  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [perPage] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [pageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [totalItemCodes, setTotalItemCodes] = useState(0);
  const [moreOption, setMoreOption] = useState(false);
  const [Items, setItems] = useState([]);
  const [itemPage, setItemPage] = useState(1);
  const itemPerPage = 50;

  const startIndex = (itemPage - 1) * itemPerPage;

  const filteredItems = Items.filter((item) => {
    if (!keyword) return true;
    return item.itemCode?.toLowerCase().includes(keyword.toLowerCase());
  });

  const paginatedItems = filteredItems.slice(
    startIndex,
    startIndex + itemPerPage,
  );

  useEffect(() => {
    getProducts();
  }, [selectedBrandId, selectedCategoryId, page, keyword]);

  useEffect(() => {
    fetchFilters();
  }, []);

  useEffect(() => {
    setItemPage(1);
  }, [keyword]);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []); // Empty dependency → runs only once on mount

  const fetchFilters = async () => {
    const brandRes = await Axios.get("/api/brand?pagination=false");
    const categoryRes = await Axios.get("/api/category?pagination=false");
    setBrands(brandRes.data.brands);
    setCategoryData(categoryRes.data.categories);
  };

  const getProducts = async () => {
    try {
      const res = await Axios.get(
        `/api/products?pageNumber=${page}&pageSize=${pageSize}&keyword=${keyword}&category=${selectedCategoryId}&brand=${selectedBrandId}`,
      );

      if (res.status >= 200 && res.status < 300) {
        console.log(res.data);
        setProducts(res.data.products);
        console.log(res.data.count);
        setTotalCount(res.data.count);
      }
    } catch (error) {
      console.error("Error fetching packages", error);
    }
  };
  console.log(totalCount, "total count");
  useEffect(() => {
    dispatch(ListCategories(""));
  }, [dispatch, successDelete]);

  const deleteHandler = async (id) => {
    if (window.confirm("Are you sure")) {
      await Axios.delete(`/api/products/${id}`);
      window.location.href = "/products";
    }
  };

  const updateActiveStatus = async (id, newStatus) => {
    if (window.confirm("Are you sure you want to update the status?")) {
      try {
        const { data } = await Axios.put(`/api/products/updateActive/${id}`, {
          active: newStatus,
        });
        if (data) {
          window.location.href = "/products";
        }
      } catch (error) {
        console.error("Error updating product status:", error);
      }
    }
  };
  console.log(page, perPage, totalCount);

  const printQR = async (item) => {
    try {
      const qrPayload = JSON.stringify({
        itemCode: item.itemCode,
        serialNumber: item.serialNumber,
      });
      const qrUrl = await QRCode.toDataURL(qrPayload);

      const myWindow = window.open("", "PRINT", "height=400,width=400");

      myWindow.document.write(`
      <html>
        <head>
          <title>QR Sticker</title>
          <style>
            body {
              margin: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100vh;
            }

            img {
              width: 150px;
              height: 150px;
            }
          </style>
        </head>

        <body>
          <img id="qrImg" src="${qrUrl}" />
        </body>
      </html>
    `);

      myWindow.document.close();

      // ✅ WAIT FOR IMAGE LOAD
      myWindow.onload = () => {
        const img = myWindow.document.getElementById("qrImg");

        if (img.complete) {
          myWindow.print();
          myWindow.close();
        } else {
          img.onload = () => {
            myWindow.print();
            myWindow.close();
          };
        }
      };
    } catch (error) {
      console.error("Print QR error:", error);
    }
  };

  // Bulk QR Code Generation Function
  const generateMissingQRCodes = async () => {
    if (
      !window.confirm(
        "This will generate QR codes for all items that don't have one. Continue?",
      )
    ) {
      return;
    }

    setIsGeneratingQR(true);

    try {
      const { data } = await Axios.post("/api/products/generate-qr-codes");

      if (data.success) {
        alert(
          `Success!\n\n${data.message}\n\nGenerated: ${data.updated} QR codes\nTotal Items: ${data.totalProcessed}`,
        );

        // Refresh the product list
        const res = await Axios.get("/api/products/itemcodes");
        setItems(res.data.items);
      }
    } catch (error) {
      console.error("Error generating QR codes:", error);
      alert(
        `Error: ${error.response?.data?.error || "Failed to generate QR codes"}`,
      );
    } finally {
      setIsGeneratingQR(false);
    }
  };
  const collectAllQRs = async () => {
    const allQRs = [];

    for (const item of paginatedItems) {
      try {
        const qrPayload = JSON.stringify({
          itemCode: item.itemCode,
          serialNumber: item.serialNumber,
        });

        const qrImg = await QRCode.toDataURL(qrPayload);

        allQRs.push({
          qrCode: qrImg,
          itemCode: item.itemCode,
          productName: item.productName,
        });
      } catch (error) {
        console.error("QR generation failed for item:", item.itemCode, error);
      }
    }

    return allQRs;
  };

  const printAllQRs = async () => {
    try {
      const allQRs = await collectAllQRs();

      if (allQRs.length === 0) {
        alert("No QR codes found to print on this page");
        return;
      }

      const printWindow = window.open("", "PRINT", "height=800,width=1000");

      if (!printWindow) {
        alert("Please allow pop-ups to print QR codes");
        return;
      }

      const qrGrid = allQRs
        .map(
          (item) => `
        <div class="qr-item">
          <img src="${item.qrCode}" alt="QR Code" crossorigin="anonymous" />
          <p class="item-code">${item.itemCode}</p>
          <p class="product-name">${item.productName}</p>
        </div>
      `,
        )
        .join("");

      printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>QR Codes - Page ${itemPage}</title>
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          @page {
            size: A4;
            margin: 10mm;
          }
          
          body {
            font-family: Arial, sans-serif;
            padding: 5mm;
          }
          
          .page-header {
            text-align: center;
            margin-bottom: 5mm;
            font-size: 12pt;
            font-weight: bold;
            page-break-after: avoid;
          }
          
          .qr-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 4mm;
            width: 100%;
          }
          
          .qr-item {
            border: 1px solid #ddd;
            padding: 2mm;
            text-align: center;
            background: white;
            page-break-inside: avoid;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 45mm;
          }
          
          .qr-item img {
            width: 35mm;
            height: 35mm;
            margin-bottom: 2mm;
            display: block;
          }
          
          .item-code {
            font-size: 9pt;
            font-weight: bold;
            margin: 1mm 0;
            word-wrap: break-word;
            max-width: 100%;
          }
          
          .product-name {
            font-size: 7pt;
            color: #666;
            margin: 0;
            word-wrap: break-word;
            max-width: 100%;
            line-height: 1.2;
          }
          
          @media print {
            body {
              padding: 0;
            }
            
            .page-header {
              margin-bottom: 3mm;
            }
            
            .qr-grid {
              gap: 3mm;
            }
          }
        </style>
      </head>
      <body>
        <div class="page-header">
          QR Codes - Page ${itemPage} (Items ${startIndex + 1} to ${Math.min(
            startIndex + itemPerPage,
            Items.length,
          )})
        </div>
        <div class="qr-grid">
          ${qrGrid}
        </div>
      </body>
    </html>
  `);

      printWindow.document.close();

      printWindow.onload = function () {
        const images = printWindow.document.getElementsByTagName("img");
        let loadedImages = 0;
        const totalImages = images.length;

        if (totalImages === 0) {
          printWindow.print();
          return;
        }

        Array.from(images).forEach((img) => {
          if (img.complete) {
            loadedImages++;
          } else {
            img.onload = () => {
              loadedImages++;
              if (loadedImages === totalImages) {
                setTimeout(() => {
                  printWindow.print();
                }, 500);
              }
            };
            img.onerror = () => {
              loadedImages++;
              if (loadedImages === totalImages) {
                setTimeout(() => {
                  printWindow.print();
                }, 500);
              }
            };
          }
        });

        if (loadedImages === totalImages) {
          setTimeout(() => {
            printWindow.print();
          }, 500);
        }
      };
    } catch (error) {
      console.error("Error printing QR codes:", error);
      alert("Error printing QR codes. Please try again.");
    }
  };
  useEffect(() => {
    Axios.get("/api/products/itemcodes").then((res) => {
      setItems(res.data.items);
      console.log(res.data.items, "items");
    });
  }, []);

  useEffect(() => {
    const closeMenu = (e) => {
      if (
        !e.target.closest(".more-option-list") &&
        !e.target.closest(".more-button")
      ) {
        setMoreOption(false);
      }
    };
    document.addEventListener("click", closeMenu);
    return () => document.removeEventListener("click", closeMenu);
  }, []);

  const getQrImage = async (item) => {
    try {
      const qrPayload = JSON.stringify({
        itemCode: item.itemCode,
        serialNumber: item.serialNumber,
      });

      return await QRCode.toDataURL(qrPayload);
    } catch (error) {
      console.error("QR generation failed:", error);
      return null;
    }
  };

  return (
    <>
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <div className="Item-code-row">
                <h4 class="card-title">Itemcode List</h4>
                <button
                  className="more-button"
                  onClick={() => setMoreOption(!moreOption)}
                >
                  <i className="mdi mdi-dots-vertical"></i>
                </button>
                {moreOption === true ? (
                  <div className="more-option-list">
                    <ul>
                      <li onClick={printAllQRs}>
                        <i className="mdi mdi-printer mr-2"></i>Prin All QR
                        Codes
                      </li>
                      <li
                        onClick={() => {
                          if (!isGeneratingQR) generateMissingQRCodes();
                        }}
                        style={{
                          opacity: isGeneratingQR ? 0.6 : 1,
                          pointerEvents: isGeneratingQR ? "none" : "auto",
                        }}
                      >
                        {isGeneratingQR ? (
                          <>
                            <span className="spinner-border spinner-border-sm mr-2"></span>
                            Generating...
                          </>
                        ) : (
                          <>
                            <i className="mdi mdi-qrcode mr-2"></i>
                            Generate Missing QR Codes
                          </>
                        )}
                      </li>
                    </ul>
                  </div>
                ) : null}
              </div>
              {/* <div class="float-right">
              <Link to="/product/create">
                {" "}
                <button type="button" class="btn btn-primary btn-md btn-block">
                  <i class="icon-plus menu-icon"></i>
                  Create
                </button>
              </Link>
            </div> */}

              <div className="row align-items-end">
                {/* Item Code */}
                {/* <div className="col-md-3">
                <label className="form-label">Item Code</label>
                <input
                  type="text"
                  placeholder="Itemcode "
                  className="form-control"
                  value={keyword}
                  onChange={(e) => {
                    setKeyword(e.target.value);
                    setPage(1);
                  }}
                />
              </div> */}

                {/* Category */}
                <div className="col-md-2">
                  <label className="form-label">Category</label>
                  <select
                    className="form-select"
                    value={selectedCategoryId}
                    onChange={(e) => {
                      setSelectedCategoryId(e.target.value);
                      setPage(1);
                    }}
                  >
                    <option value="all">All</option>

                    {categorydata.map((cat) => (
                      <option key={cat._id} value={cat._id}>
                        {cat.categoryName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-2">
                  <label className="form-label">Brand</label>
                  <select
                    className="form-select"
                    value={selectedBrandId}
                    onChange={(e) => {
                      setSelectedBrandId(e.target.value);
                      setPage(1);
                    }}
                  >
                    <option value="all">All</option>

                    {brands.map((brand) => (
                      <option key={brand._id} value={brand._id}>
                        {brand.brandName}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Item Code Search */}
                <div className="col-md-2">
                  <label className="form-label">Item Code</label>
                  <input
                    type="text"
                    placeholder="Search by Item Code"
                    className="form-control"
                    value={keyword}
                    onChange={(e) => {
                      setKeyword(e.target.value);
                    }}
                  />
                </div>
                {/* Serial Number */}
                {/* <div className="col-md-2">
             <label className="form-label">Serial Number</label>
                <input
                  type="text"
                  placeholder="serialnumber "
                  className="form-control"
                  value={keyword}
                  onChange={(e) => {
                    setKeyword(e.target.value);
                    setPage(1);
                  }}
                />
              </div> */}
              </div>

              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Sl No</th>
                      <th>Item code</th>
                      <th>serialNumber </th>
                      <th>Product Name</th>
                      <th>Qr Code</th>
                    </tr>
                  </thead>
                  {/* <tbody>
                    {products?.length > 0 ? (
                      products.flatMap((product, prodIndex) =>
                        product.stock?.length > 0 ? (
                          product.stock.map((stockItem, stockIndex) => (
                            <tr key={`${product._id}-${stockIndex}`}>
                              <td>
                                {stockIndex === 0
                                  ? (page - 1) * perPage + prodIndex + 1
                                  : ""}{" "}
                               
                              </td>
                              <td>
                                <Link to={`/item/${stockItem.itemCode}`}>
                                  {stockItem.itemCode}
                                </Link>
                              </td>
                              <td>{stockItem.serialNumber}</td>
                              <td>{product.name}</td>
                              <td>
                                <img
                                  src={stockItem.qrCode}
                                  alt="QR Code"
                                  className="qr-img"
                                  style={{ width: "60px", height: "60px" }}
                                />

                                <button
                                  className="btn btn-sm btn-primary mt-2"
                                  style={{ marginLeft: "20px" }}
                                  onClick={() =>
                                    printQR(
                                      stockItem.qrCode,
                                      stockItem.itemCode,
                                      product.name
                                    )
                                  }
                                >
                                  <FaDownload style={{ marginRight: "6px" }} />
                                  Print QR
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr key={`${product._id}-no-stock`}>
                            <td colSpan={2}>
                              <span className="text-danger">No Itemcode</span>
                            </td>
                            <td>{product.name}</td>
                            <td>
                              <div className="d-flex flex-wrap">
                                <div className="p-2">
                                  <button
                                    type="button"
                                    className={`btn btn-sm ${
                                      product.active
                                        ? "btn-outline-danger"
                                        : "btn-outline-success"
                                    }`}
                                    onClick={() =>
                                      updateActiveStatus(
                                        product._id,
                                        !product.active
                                      )
                                    }
                                  >
                                    {product.active ? "Disable" : "Enable"}
                                  </button>
                                </div>
                                <div className="p-2">
                                  <Link to={`/product/edit/${product._id}`}>
                                    <button
                                      type="button"
                                      className="btn btn-outline-dark btn-sm"
                                    >
                                      Edit
                                    </button>
                                  </Link>
                                </div>
                                <div className="p-2">
                                  <button
                                    type="button"
                                    className="btn btn-outline-danger btn-sm"
                                    onClick={() => deleteHandler(product._id)}
                                  >
                                    Delete
                                  </button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td colSpan={4}>No Products Found</td>
                      </tr>
                    )}
                  </tbody> */}
                  <tbody>
                    {paginatedItems.length > 0 ? (
                      paginatedItems.map((item, index) => (
                        <tr key={item.itemCode}>
                          <td>{startIndex + index + 1}</td>
                          <td>
                            <Link to={`/item/${item.itemCode}`}>
                              {item.itemCode}
                            </Link>
                          </td>
                          <td>{item.serialNumber}</td>
                          <td>{item.productName}</td>
                          <td>
                            <QRCodeSVG
                              value={JSON.stringify({
                                itemCode: item.itemCode,
                                serialNumber: item.serialNumber,
                              })}
                              size={60}
                            />
                            <button
                              className="btn btn-sm btn-primary mt-2"
                              style={{ marginLeft: "20px" }}
                              onClick={() => printQR(item)}
                            >
                              <FaDownload style={{ marginRight: "6px" }} />
                              Print QR
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={5}>No Item Codes Found</td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* <Pagination
                  page={page}
                  perPage={perPage}
                  setPage={setPage}
                  totalCount={totalCount}
                /> */}
                <Pagination
                  page={itemPage}
                  perPage={itemPerPage}
                  setPage={setItemPage}
                  totalCount={filteredItems.length}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="print-area" style={{ display: "none" }}>
        <div
          id="qr-print-content"
          style={{ textAlign: "center", padding: "10px" }}
        >
          <img id="qr-print-img" src="" alt="QR" style={{ width: "130px" }} />
          <p
            id="qr-print-item"
            style={{ fontSize: "16px", fontWeight: "bold" }}
          ></p>
          <p id="qr-print-product" style={{ fontSize: "14px" }}></p>
        </div>
      </div>
    </>
  );
};

export default LstProduct;
